import { render, staticRenderFns } from "./CancellationScopeSection.vue?vue&type=template&id=5f1b0f81&scoped=true"
import script from "./CancellationScopeSection.vue?vue&type=script&lang=js"
export * from "./CancellationScopeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b0f81",
  null
  
)

export default component.exports